var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.666-90.667q-43.699 0-74.849-31.15-31.15-31.15-31.15-74.849v-566.668q0-43.974 31.15-75.32Q152.967-870 196.666-870h566.668q43.974 0 75.32 31.346Q870-807.308 870-763.334v566.668q0 43.699-31.346 74.849-31.346 31.15-75.32 31.15H196.666Zm0-105.999h566.668v-566.668H196.666v566.668Zm0 0v-566.668 566.668ZM274-267.333h413.334q15.666 0 22.999-14.584 7.334-14.583-2-28.083l-111-153.667q-8.205-9-21.769-9.5-13.564-.5-21.23 10.167L447.333-325l-69.667-96q-9.205-10.666-22.769-10.166-13.564.5-20.897 10.499L253-310q-10 13.5-2.667 28.083 7.334 14.584 23.667 14.584Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit-image.c378f810900c429e8d4362206ce09ce0.svg";
export { ForwardRef as ReactComponent };